import { render } from "./GoalsIcon.vue?vue&type=template&id=9f39f00e"
import script from "./GoalsIcon.vue?vue&type=script&lang=js"
export * from "./GoalsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script